// frontend/src/pages/reports/SalaryComplaintsReport.js
import React, { useEffect, useState } from 'react';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, Chip, Box, TextField, InputAdornment, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import ReportTemplate from '../../components/reports/ReportTemplate';
import { getSalaryComplaintsReport } from '../../services/reportService';

const TYPE_COLORS = { UNDERPAYMENT:'error', OVERPAYMENT:'warning', NON_PAYMENT:'error', WRONG_ALLOWANCE:'warning', WRONG_DEDUCTION:'warning', DATE_OF_BIRTH_ERROR:'info', OTHER:'default' };

const SalaryComplaintsReport = () => {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');
  const [search, setSearch]   = useState('');
  const [typeFilter, setTypeFilter] = useState('ALL');

  const load = async () => {
    setLoading(true); setError('');
    try { const res = await getSalaryComplaintsReport(); setData(res.data.data); }
    catch (err) { setError(err.response?.data?.message || 'Failed to load report'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const allComplaints = data?.complaints || [];
  const types = ['ALL', ...Object.keys(data?.summary?.byType || {})];
  const complaints = allComplaints.filter(c => {
    const matchSearch = c.personnelName.toLowerCase().includes(search.toLowerCase()) || c.serviceNumber.toLowerCase().includes(search.toLowerCase());
    const matchType = typeFilter === 'ALL' || c.complaintType === typeFilter;
    return matchSearch && matchType;
  });

  const summaryItems = data?.summary ? [
    { label: 'Total Complaints', value: data.summary.totalComplaints, color: 'error.main', bg: '#ffebee' },
    ...Object.entries(data.summary.byType || {}).map(([type, count]) => ({
      label: type.replace(/_/g,' '), value: count, color: 'warning.main', bg: '#fff3e0',
    })),
  ] : [];

  const exportCols = [
    { key:'serviceNumber', label:'Service Number' }, { key:'personnelName', label:'Name' },
    { key:'rank', label:'Rank' }, { key:'command', label:'Command' }, { key:'zone', label:'Zone' },
    { key:'complaintType', label:'Complaint Type' }, { key:'details', label:'Details' },
    { key:'status', label:'Status' }, { key:'referenceNumber', label:'Reference No.' },
    { key:'verifiedBy', label:'Verified By' }, { key:'verifiedAt', label:'Verified At' },
  ];

  return (
    <ReportTemplate title="Salary Complaints Report" subtitle={data?.exercise ? `${data.exercise.name} — ${data.exercise.year}` : ''}
      loading={loading} error={error} onRefresh={load}
      exportFileName="Salary_Complaints_Report" exportData={allComplaints} exportColumns={exportCols}
      summaryItems={summaryItems}>
      <Paper elevation={2} sx={{ p: 3 }}>
        <Box display="flex" gap={2} mb={2} flexWrap="wrap">
          <TextField size="small" placeholder="Search by name or SN..." value={search}
            onChange={(e) => setSearch(e.target.value)} sx={{ flex: 1, minWidth: 200 }}
            InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment> }} />
          <FormControl size="small" sx={{ minWidth: 200 }}>
            <InputLabel>Complaint Type</InputLabel>
            <Select value={typeFilter} label="Complaint Type" onChange={(e) => setTypeFilter(e.target.value)}>
              {types.map((t) => <MenuItem key={t} value={t}>{t.replace(/_/g,' ')}</MenuItem>)}
            </Select>
          </FormControl>
        </Box>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor:'grey.100' }}>
              {['Service No.','Name','Rank','Command','Zone','Type','Details','Status','Verified By'].map(h =>
                <TableCell key={h}><strong>{h}</strong></TableCell>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {complaints.map((c) => (
              <TableRow key={c.id} hover>
                <TableCell sx={{fontWeight:'bold'}}>{c.serviceNumber}</TableCell>
                <TableCell>{c.personnelName}</TableCell>
                <TableCell>{c.rank}</TableCell>
                <TableCell>{c.commandCode}</TableCell>
                <TableCell><Chip label={c.zone} size="small" variant="outlined" sx={{fontSize:'0.65rem'}}/></TableCell>
                <TableCell><Chip label={c.complaintType.replace(/_/g,' ')} size="small" color={TYPE_COLORS[c.complaintType]||'default'}/></TableCell>
                <TableCell sx={{maxWidth:200, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>{c.details}</TableCell>
                <TableCell><Chip label={c.status} size="small" color={c.status==='PENDING'?'warning':'success'}/></TableCell>
                <TableCell>{c.verifiedBy}</TableCell>
              </TableRow>
            ))}
            {complaints.length === 0 && <TableRow><TableCell colSpan={9} align="center" sx={{py:4,color:'text.secondary'}}>No complaints found</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Paper>
    </ReportTemplate>
  );
};
export default SalaryComplaintsReport;